export default __webpack_public_path__ + "static/media/secondary.b03262eed6ec3ba7afff4c406060155b.svg";